import { IS_PRO, IS_PRE, IS_SIM, IS_DEV, IS_SODA } from '@/config/constants'

const envMap = {
  development: 'dev',
  dev: 'dev',
  production: 'pro',
  pro: 'pro',
  pre: 'pre',
  sim: 'dev',
  mock: 'mock',
}
export const getEnv = config => {
  if (IS_PRE) {
    return 'pre'
  }
  if (IS_PRO) {
    return 'pro'
  }
  return envMap[config.apiEnv || 'sim']
}
// 有限走这个
export const getBaseHttpHost = () => {
  if (IS_SIM) {
    return window.location.origin + '/dilu'
  }
  if (IS_DEV) {
    return window.location.origin
  }

  if (IS_SODA) {
    return window.location.origin
  }

  return ''
}
